enum MiscCodeTypes {
  ICD_10_CM = "ICD10_CM"
}

export default MiscCodeTypes;
